export default {"src":"/_next/static/image/public/images/temp_password_locked.b4050abb47b206da69cd8ccf70364bd4.svg","height":139,"width":133};